module.exports = __webpack_public_path__ + "static/media/black_shred_logo.c7fba57f.svg";